import styled from 'styled-components';

export const IconWrapper = styled.div`
  width: 20px;
  height: 20px;
  cursor: pointer;
`

export const BigIconWrapper = styled.div`
  width: 30px;
  height: 30px;
  cursor: pointer;
`



// WEBPACK FOOTER //
// ./src/assets/icons/IconWrappers.js